import { Customer, PaymentSource } from '@fairandsmart/types';
import { Action } from '@ngrx/store';

export enum ConfigurationActionTypes {
  PaymentSourceAdded = '[Customer] Payment source added',
  PaymentSourceRemoved = '[Customer] Payment source removed',
  ShippingDetailsUpdated = '[Customer] Shipping details updated',
}

export class PaymentSourceAdded implements Action {
  readonly type = ConfigurationActionTypes.PaymentSourceAdded;

  constructor(public payload: { paymentSource: PaymentSource }) {}
}

export class PaymentSourceRemoved implements Action {
  readonly type = ConfigurationActionTypes.PaymentSourceRemoved;
}

export class ShippingDetailsUpdated implements Action {
  readonly type = ConfigurationActionTypes.ShippingDetailsUpdated;

  constructor(public payload: { updatedCustomer: Customer }) {}
}

export type ConfigurationActions = PaymentSourceAdded | PaymentSourceRemoved | ShippingDetailsUpdated;
